import React, { useRef, useState } from 'react'
import { Canvas, useFrame } from 'react-three-fiber'
import _ from 'lodash'

function Box(props) {
  console.log('HEYO!', props);
  // This reference will give us direct access to the mesh
  const mesh = useRef()

  // Set up state for the hovered and active state
  const [hovered, setHover] = useState(false)
  const [active, setActive] = useState(false)

  // Rotate mesh every frame, this is outside of React without overhead
  useFrame(() => (mesh.current.rotation.x = mesh.current.rotation.y += 0.01))

  return (
    <mesh
      {...props}
      ref={mesh}
      scale={active ? [1.5, 1.5, 1.5] : [1, 1, 1]}
      onClick={(e) => setActive(!active)}
      onPointerOver={(e) => setHover(true)}
      onPointerOut={(e) => setHover(false)}>
      <boxBufferGeometry attach="geometry" args={[1, 1, 1]} />
      <meshBasicMaterial attach="material" color={hovered ? 'hotpink' : 'orange'} />
    </mesh>
  )
}

const GizmoInside = ({ numBoxes }) => {
  const boxes = _.range(numBoxes).map(i => <Box key={i} position={[-1.5 + 3*i/numBoxes, 0, 0]} />)
  console.log('HMM', numBoxes, boxes[0]);
  return (
    <Canvas>
      <ambientLight />
      <pointLight position={[10, 10, 10]} />
      <>{boxes}</>
    </Canvas>
  )
}

export class Gizmo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null
    };
  }

  static getDerivedStateFromError(error) {
    console.log('OHNO!', error);
    return { error };
  }

  render() {
    const { error } = this.state;
    return (
      <div style={{width: 600, height: 400, border: `1px solid dodgerblue`}}>
        HUH
        { error ? `OHNO! ${error.message}` : <GizmoInside {...this.props} /> }
      </div>
    );
  }

}